/** @jsxImportSource @emotion/react */

import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import * as classes from './styles'

export type PassagePreviewProps = {
  title: string
  passageContent: string
  videoWalkthrough: string | null
  expanded: boolean
  onExpandClick: () => void
  onEditClick: () => void
  isPassageOnly?: boolean
}

export const PassagePreview = ({
  title,
  passageContent,
  videoWalkthrough,
  expanded,
  onExpandClick,
  onEditClick,
  isPassageOnly,
}: PassagePreviewProps) => (
  <Accordion
    expanded={expanded}
    onChange={onExpandClick}
    css={[classes.accordion, isPassageOnly && classes.accordionSingle]}
  >
    <AccordionSummary css={classes.accordionSummary}>
      <div css={[classes.accordionSummaryBlock, classes.accordionSummaryTitleBlock]}>
        <Typography variant="body2" css={classes.title} data-testid="passage-title">
          {title}
        </Typography>
      </div>
      <div css={classes.accordionSummaryBlock}>
        {!isPassageOnly && (
          <EditIcon
            css={[classes.icon, classes.iconEdit]}
            onClick={(e) => {
              e.stopPropagation()
              onEditClick()
            }}
            data-testid="passage-edit-button"
          />
        )}
        <ExpandMoreRoundedIcon
          css={[classes.iconChevron, expanded && classes.iconChevronOpen]}
          data-testid="passage-expand-icon"
        />
      </div>
    </AccordionSummary>
    <AccordionDetails css={classes.accordionDetails}>
      <div css={classes.htmlBlock} dangerouslySetInnerHTML={{ __html: passageContent }} data-testid="passage-text" />
      {!isPassageOnly && (
        <div css={classes.mainSolutionVideoBlock}>
          Passage Walkthrough Video:{' '}
          <span data-testid="passage-walkthrough-video-link">
            {videoWalkthrough ? (
              <a href={videoWalkthrough} target="_blank" rel="noopener noreferrer">
                {videoWalkthrough}
              </a>
            ) : (
              '-'
            )}
          </span>
        </div>
      )}
    </AccordionDetails>
  </Accordion>
)
